import axios from '../config/axios';


export const getCityOptions = (value) => {
  if (value.trim()) {
    const url = `/common/get-city?q=${value.trim()}`;
    return axios.get(url)
      .then((response) => {
        return response.data.map(item => ({ value: item.id, label: item.display_name }));
      })
      .catch(() => {
        alert('Something went wrong!')  // eslint-disable-line
      });
  }
  return [];
};


export const getCountryOptions = (value) => {
  if (value.trim()) {
    const url = `/common/get-country?q=${value.trim()}`;
    return axios.get(url)
      .then((response) => {
        return response.data.map(item => ({ value: item.id, label: item.name }));
      })
      .catch(() => {
        alert('Something went wrong!')  // eslint-disable-line
      });
  }
  return [];
};


export const getCountryOptionsSlug = (value) => {
  if (value.trim()) {
    const url = `/common/get-country?q=${value.trim()}`;
    return axios.get(url)
      .then((response) => {
        return response.data.map(item => ({ value: item.slug, label: item.name }));
      })
      .catch(() => {
        alert('Something went wrong!')  // eslint-disable-line
      });
  }
  return [];
};


export const getCasteOptions = () => {
  const url = '/profiles/get-caste';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.id, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getCasteOptionsSlug = () => {
  const url = '/profiles/get-caste';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.slug, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getMaritalStatusOptions = () => {
  const url = '/profiles/get-marital-status';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.id, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getMaritalStatusOptionsSlug = () => {
  const url = '/profiles/get-marital-status';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.slug, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getOptionConstants = (type) => {
  const url = `/profiles/get-option-constants?option=${type}`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getDegrees = (value) => {
  let url = '/profiles/get-degrees';
  if (value) {
    url = `/profiles/get-degrees?q=${value}`;
  }
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({
        value: item.id,
        label: item.is_parent === true ? `---${item.name}---` : item.name,
        is_parent: item.is_parent,
      }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getDegreesSlug = (value) => {
  let url = '/profiles/get-degrees';
  if (value) {
    url = `/profiles/get-degrees?q=${value}`;
  }
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({
        value: item.slug,
        label: item.is_parent === true ? `---${item.name}---` : item.name,
        is_parent: item.is_parent,
      }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getStudyField = (value) => {
  let url = '/profiles/get-study_field';
  if (value) {
    url = `/profiles/get-study_field?q=${value}`;
  }
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({
        value: item.id,
        label: item.name,
      }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getWorkProfile = (value) => {
  let url = '/profiles/get-work_profile';
  if (value) {
    url = `/profiles/get-work_profile?q=${value}`;
  }
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.id, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getWorkProfileSlug = () => {
  const url = '/profiles/get-work_profile';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.slug, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getIncome = () => {
  const url = '/profiles/get-income';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.id, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getIncomeSlug = () => {
  const url = '/profiles/get-income';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.slug, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getBureauOptions = () => {
  const url = '/profiles/get-bureau';
  return axios.get(url)
    .then((response) => {
      return response.data.map(item => ({ value: item.id, label: item.name }));
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getFromIndiaOptions = () => {
  const url = '/profiles/get-bureau';
  return axios.get(url)
    .then(() => {
      return [{ value: 1, label: 'Living in India' }, { value: 0, label: 'Living outside India' }];
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};


export const getPremiumOptions = () => {
  const url = '/profiles/get-bureau';
  return axios.get(url)
    .then(() => {
      return [{ value: 1, label: 'Show Premium profiles' }, { value: 0, label: 'Show regular profiles' }];
    })
    .catch(() => {
      alert('Something went wrong!')  // eslint-disable-line
    });
};



// WEBPACK FOOTER //
// ./src/common/asyncSelectData.js